export const NLD_LL_ADDRESS_HEADER = [
  { headerName: 'Link ID' },
  {
    headerName: 'Bandwidth',
    isSortable: true,
    sortKey: 'BANDWIDTH',
    sortValue: 'default'
  },
  { headerName: 'Site Type' },
  { headerName: 'Installation Address' },
  { headerName: 'Company Name' },
  { headerName: 'Pincode' }
];

export const DI_ADDRESS_HEADER = [
  { headerName: 'Site ID' },
  { headerName: 'Company Name' },
  { headerName: 'Installation Address' },
  { headerName: 'Pincode' },
  {
    headerName: 'Bandwidth',
    isSortable: true,
    sortKey: 'BANDWIDTH',
    sortValue: 'default'
  }
];

export const VPN_ADDRESS_HEADER = [
  { headerName: 'Link ID' },
  { headerName: 'Company Name' },
  { headerName: 'Installation Address' },

  { headerName: 'Pincode' },
  { headerName: 'Site Type' },
  {
    headerName: 'Bandwidth',
    isSortable: true,
    sortKey: 'BANDWIDTH',
    sortValue: 'default'
  }
];

export const AOI_1000_SITES_ADDRESS_HEADER = [
  { headerName: 'Feasibility ID' },
  { headerName: 'Installation Address' },
  { headerName: 'Pincode' },
  { headerName: 'Network Status' }
  // {
  //   headerName: 'Bandwidth',
  //   isSortable: true,
  //   sortKey: 'BANDWIDTH',
  //   sortValue: 'default'
  // }
];

export const BULK_TABLE_HEADER = [
  { headerName: 'Circuit ID' },
  { headerName: 'Installation Address (Branch Code)' },
  { headerName: 'Current Bandwidth, Media' },
  { headerName: 'Current Service Type' },
  {
    headerName: 'Required Bandwidth',
    isSortable: true,
    sortKey: 'BANDWIDTH',
    sortValue: 'default'
  },
  { headerName: 'Required Service Type' },
  { headerName: 'Router Make and Model ' }
];

export const NLD_LL_FSB_HEADER = [
  {
    headerName: 'Link ID'
  },
  {
    headerName: 'Order Request ID'
  },
  {
    headerName: 'Bandwidth',
    isSortable: true,
    sortKey: 'BANDWIDTH',
    sortValue: 'default'
  },
  {
    headerName: 'Site Type'
  },
  {
    headerName: 'Installation Address'
  },
  {
    headerName: 'Network Status'
  },
  {
    headerName: 'Media Type'
  }
];

export const DI_FSB_HEADER = [
  {
    headerName: 'Site ID'
  },
  {
    headerName: 'Order Request ID'
  },
  {
    headerName: 'Installation Address'
  },
  {
    headerName: 'Network Status'
  },
  {
    headerName: 'Bandwidth',
    isSortable: true,
    sortKey: 'BANDWIDTH',
    sortValue: 'default'
  },
  {
    headerName: 'Media Type'
  }
];

export const VPN_FSB_HEADER = [
  {
    headerName: 'Link ID'
  },
  {
    headerName: 'Order Request ID'
  },
  {
    headerName: 'Installation Address'
  },
  {
    headerName: 'Site Type'
  },

  {
    headerName: 'Network Status'
  },
  {
    headerName: 'Bandwidth',
    isSortable: true,
    sortKey: 'BANDWIDTH',
    sortValue: 'default'
  },
  {
    headerName: 'Media Type'
  }
];

export const AOI_1000_SITES_FSB_HEADER = [
  {
    headerName: 'Feasibility ID'
  },
  // {
  //   headerName: 'Order Request ID'
  // },
  {
    headerName: 'Installation Address'
  },
  // {
  //   headerName: 'Site Type'
  // },

  {
    headerName: 'Pincode'
  },

  {
    headerName: 'Network Status'
  }
  // {
  //   headerName: 'Bandwidth',
  //   isSortable: true,
  //   sortKey: 'BANDWIDTH',
  //   sortValue: 'default'
  // },
  // {
  //   headerName: 'Media Type'
  // }
];

export const UPGRADE_FEASIBILITY_HEADER = [
  {
    headerName: 'Circuit ID'
  },
  {
    headerName: 'Order Request ID'
  },
  {
    headerName: 'Installation Address'
  },
  {
    headerName: 'Network Status'
  },
  {
    headerName: 'Current Bandwidth, Media'
  },
  {
    headerName: 'Requested Bandwidth',
    isSortable: true,
    sortKey: 'BANDWIDTH',
    sortValue: 'default'
  },
  {
    headerName: 'Requested Service Type'
  }
];

export const NLD_LL_CART_HEADER = [
  {
    headerName: 'Link ID'
  },
  {
    headerName: 'Bandwidth',
    isSortable: true,
    sortKey: 'BANDWIDTH',
    sortValue: 'default'
  },
  {
    headerName: 'Site Type'
  },
  {
    headerName: 'Installation Address'
  },
  {
    headerName: 'Media Type'
  }
];

export const UPGRADE_CART_HEADER = [
  {
    headerName: 'Circuit ID'
  },
  {
    headerName: 'Installation Address'
  },
  {
    headerName: 'Requested Bandwidth',
    isSortable: true,
    sortKey: 'BANDWIDTH',
    sortValue: 'default'
  },
  {
    headerName: 'Requested Service Type'
  },
  {
    headerName: 'Requested Hardware (CPE) Type & Specification'
  }
];

export const VPN_CART_HEADER = [
  {
    headerName: 'Link ID'
  },
  {
    headerName: 'Installation Address'
  },
  {
    headerName: 'Site Type'
  },

  {
    headerName: 'Bandwidth',
    isSortable: true,
    sortKey: 'BANDWIDTH',
    sortValue: 'default'
  },
  {
    headerName: 'Media Type'
  }
];

export const AOI_1000_SITES_CART_HEADER = [
  {
    headerName: 'Feasibility ID'
  },
  {
    headerName: 'Installation Address'
  },
  {
    headerName: 'Pincode'
  },
  {
    headerName: 'Network Staus'
  }
  // {
  //   headerName: 'Site Type'
  // },

  // {
  //   headerName: 'Bandwidth',
  //   isSortable: true,
  //   sortKey: 'BANDWIDTH',
  //   sortValue: 'default'
  // },
  // {
  //   headerName: 'Media Type'
  // }
];

export const DI_CART_HEADER = [
  {
    headerName: 'Site ID'
  },
  {
    headerName: 'Installation Address'
  },
  {
    headerName: 'Bandwidth',
    isSortable: true,
    sortKey: 'BANDWIDTH',
    sortValue: 'default'
  },
  {
    headerName: 'Media Type'
  }
];
